var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chip-status-click",on:{"click":function($event){$event.preventDefault();return _vm.onClick()}}},[_c('chip-status',_vm._b({},'chip-status',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }